// Safari v12 has no MediaQueryList.prototype.addEventListener, This API was implemented in Safari v14.
// TODO: Safari/ios_saf それぞれv14未満のサポートがなくなったらこのpolyfillは削除して良い ref: client/generated/coreJsImport.ts

if (typeof matchMedia !== "undefined" && !matchMedia("all").addEventListener) {
  console.log("installing polyfill: MediaQueryList.prototype.addEventListener");

  const originalMatchMedia = matchMedia;
  self.matchMedia = function matchMedia(this: typeof self, mediaQuery: string): MediaQueryList {
    const mql = originalMatchMedia(mediaQuery);
    mql.addEventListener = function (
      this: MediaQueryList,
      _eventName: "change",
      listener: EventListenerOrEventListenerObject,
    ) {
      this.addListener(listener as any);
    };
    return mql;
  };
}
